import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import PhoneInput from "react-phone-number-input";

export const FormInput = styled(OutlinedInput)`
  width: 100%;
  height: 33px;

  input {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 14px;
  }
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-bottom: 16px;

  & .MuiOutlinedInput-notchedOutline {
    border-color: #ccd1d9;
  }

  & .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #4faee0;
  }

  & .Mui-focused.MuiInputLabel-outlined {
    color: #4faee0;
  }

  & .MuiFormLabel {
    color: #4faee0;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    background: none;
    background-color: none;
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  & .MuiSelect-icon {
    fill: #4faee0;
  }
`;

export const FieldError = styled.span`
  font-size: 15px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.palette.error.main};
  width: 100%;
  white-space: pre-line;
`;

export const PhoneInputWrapper = styled(PhoneInput)`
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;

  input {
    width: 100%;
    border: 0;
    border-radius: 5px;
    margin-bottom: 0;
    padding: 16px;
  }
`;
